/* import __COLOCATED_TEMPLATE__ from './adi.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();